<template>
  <div class="sectionHeading">
    <slot v-if="$slots.label" name="label"></slot>
    <h3 v-else>{{ label }}</h3>
    <div class="ml-auto">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: ""
  }
});
</script>

<style lang="scss">
.sectionHeading {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  padding-bottom: 6px;
}
</style>
